import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getProducts = async ({ includeInactive = false, excludeIntermediate = false } = {}) => {
    const token = localStorage.getItem('token');
    const params = {};
    if (includeInactive) params.includeInactive = 'true';
    if (excludeIntermediate) params.excludeIntermediate = 'true';
    const response = await axios.get(`${API_URL}/api/products`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
    });
    return response.data;
};

const createProduct = async (name, companyId, recipe, defaultUnitsPerCart, sku, productType = 'manufactured', extra = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(
        `${API_URL}/api/products`,
        { name, companyId, recipe, defaultUnitsPerCart: defaultUnitsPerCart !== '' ? defaultUnitsPerCart : null, sku: sku || null, productType, ...extra },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};

const updateProduct = async (id, name, companyId, recipe, defaultUnitsPerCart, extra = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(
        `${API_URL}/api/products/${id}`,
        { name, companyId, recipe, defaultUnitsPerCart: defaultUnitsPerCart !== '' ? defaultUnitsPerCart : null, ...extra },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};

// New: Get the product recipe (i.e. the ingredient IDs associated with the product)
const getProductRecipe = async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/api/products/${id}/recipe`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  };
  
const getRecipeCosts = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/api/products/recipe-costs`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data; // [{ productId, estimatedCostPerUnit }]
};

const reorderProducts = async (orders) => {
  const token = localStorage.getItem('token');
  const response = await axios.patch(`${API_URL}/api/products/reorder`, { orders }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const toggleActive = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.patch(`${API_URL}/api/products/${id}/toggle-active`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data; // { id, isActive }
};

const cloneProduct = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/api/products/${id}/clone`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const getPresentations = (productId) =>
  axios.get(`${API_URL}/api/products/${productId}/presentations`, auth()).then(r => r.data);

const createPresentation = (productId, data) =>
  axios.post(`${API_URL}/api/products/${productId}/presentations`, data, auth()).then(r => r.data);

const updatePresentation = (productId, presId, data) =>
  axios.put(`${API_URL}/api/products/${productId}/presentations/${presId}`, data, auth()).then(r => r.data);

const deletePresentation = (productId, presId) =>
  axios.delete(`${API_URL}/api/products/${productId}/presentations/${presId}`, auth()).then(r => r.data);

const clonePresentations = (targetProductId, fromProductId) =>
  axios.post(`${API_URL}/api/products/${targetProductId}/clone-presentations?fromProductId=${fromProductId}`, {}, auth()).then(r => r.data);

const confirmGtins = (assignments) =>
  axios.post(`${API_URL}/api/products/gtin-confirm`, { assignments }, auth()).then(r => r.data);

// QA reference photo for the AI Visual Inspection SQF checklist field type.
const getQaReferenceUploadUrl = (productId, fileName, contentType, fileSize) =>
  axios.post(`${API_URL}/api/products/${productId}/qa-reference-upload-url`, { fileName, contentType, fileSize }, auth()).then(r => r.data);

  const productService = {
    getProducts,
    createProduct,
    updateProduct,
    getProductRecipe,
    getRecipeCosts,
    reorderProducts,
    toggleActive,
    cloneProduct,
    getPresentations,
    createPresentation,
    updatePresentation,
    deletePresentation,
    clonePresentations,
    confirmGtins,
    getQaReferenceUploadUrl,
  };

export default productService;
